import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const highlights = [
  {
    icon: 'ri-home-heart-line',
    label: '自身の家づくり経験',
    desc: '実際に鳥取で家を建てた経験をもとに、初心者が感じるリアルな不安や疑問を記事に反映しています。',
  },
  {
    icon: 'ri-search-eye-line',
    label: '住宅会社への取材',
    desc: '地域の住宅会社への取材内容をもとに、現場のリアルな情報を提供しています。',
  },
  {
    icon: 'ri-shield-check-line',
    label: '広告・営業に偏らない',
    desc: '特定の会社や商品を推薦するのではなく、読者の不安を減らすことを目的に運営しています。',
  },
];

const recentArticles = [
  { id: 63, title: '鳥取の家づくり総額はどう変わる？金利2.0〜2.5％時代の年収別予算と失敗しない資金計画' },
  { id: 61, title: '【鳥取版】地盤と耐震で後悔しない家づくり｜地盤調査・耐震等級・地震リスクの基礎知識まとめ' },
  { id: 60, title: '【鳥取版】断熱・気密で後悔しない家づくり｜UA値・C値の基準と最適な選び方（初心者向け）' },
];

export default function ProfilePage() {
  return (
    <div className="min-h-screen bg-[#FAF7F4]">
      <Navbar />

      {/* Hero */}
      <div className="bg-[#F0EBE3] pt-28 pb-12">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-[#A0A0A0] mb-4">
            <Link to="/" className="hover:text-[#8FA882] transition-colors cursor-pointer">ホーム</Link>
            <i className="ri-arrow-right-s-line text-[#C0B8B0]" />
            <span className="text-[#6B6B6B]">運営者プロフィール</span>
          </nav>
          <h1 className="text-2xl md:text-3xl font-bold text-[#2C2C2C] mb-3">運営者プロフィール</h1>
          <p className="text-sm text-[#6B6B6B]">このサイトを運営している人について</p>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-6 py-14">

        {/* Profile Card */}
        <div className="bg-white rounded-xl border border-[#EDE7DE] p-8 md:p-10 mb-8">
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-7 mb-8">
            {/* Avatar */}
            <div className="shrink-0">
              <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-[#EDE7DE]">
                <img
                  src="https://public.readdy.ai/ai/img_res/ce020bdb5bece38846226a2e4df6ccf1.jpg"
                  alt="鳥取砂丘のイメージ"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Name & Tag */}
            <div className="text-center sm:text-left">
              <div className="flex items-center justify-center sm:justify-start gap-3 mb-2">
                <h2 className="text-2xl font-bold text-[#2C2C2C]">vora</h2>
                <span className="text-xs font-medium px-3 py-1 rounded-full bg-[#EAF3E7] text-[#6A9B5E]">運営者</span>
              </div>
              <p className="text-sm text-[#8FA882] font-medium mb-3">鳥取ではじめての家づくりガイド</p>
              <div className="flex items-center justify-center sm:justify-start gap-2 text-xs text-[#A0A0A0]">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line" />
                </div>
                <span>鳥取県在住</span>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-[#F0EBE3] mb-8" />

          {/* Bio */}
          <div className="mb-8">
            <h3 className="text-sm font-bold text-[#2C2C2C] border-l-4 border-[#8FA882] pl-3 mb-4">
              このサイトについて
            </h3>
            <p className="text-sm text-[#555] leading-relaxed">
              当サイトでは、鳥取で家づくりを検討する20〜30代の方に向けて、地域の住宅事情や失敗しないためのポイントをわかりやすくまとめています。自身の家づくり経験や、住宅会社への取材内容をもとに、初心者でも安心して読める情報提供を心がけています。広告や営業に偏らず、読者の不安を減らすことを目的に運営しています。
            </p>
          </div>

          {/* Highlights */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {highlights.map((item) => (
              <div
                key={item.label}
                className="bg-[#FAF7F4] rounded-lg p-5 border border-[#EDE7DE]"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EAF3E7] mb-3">
                  <i className={`${item.icon} text-[#8FA882] text-base`} />
                </div>
                <p className="text-xs font-bold text-[#2C2C2C] mb-1.5">{item.label}</p>
                <p className="text-xs text-[#6B6B6B] leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Recent Articles */}
        <div className="bg-white rounded-xl border border-[#EDE7DE] p-8 md:p-10 mb-8">
          <h3 className="text-sm font-bold text-[#2C2C2C] border-l-4 border-[#8FA882] pl-3 mb-5">
            最近書いた記事
          </h3>
          <ul className="space-y-3">
            {recentArticles.map((article) => (
              <li key={article.id}>
                <Link
                  to={`/articles/${article.id}`}
                  className="flex items-start gap-3 group cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                    <i className="ri-article-line text-[#8FA882] text-sm" />
                  </div>
                  <span className="text-sm text-[#555] group-hover:text-[#8FA882] transition-colors leading-relaxed">
                    {article.title}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-5 pt-5 border-t border-[#F0EBE3]">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 text-sm text-[#8FA882] hover:text-[#7A9570] transition-colors cursor-pointer font-medium"
            >
              すべての記事を見る
              <i className="ri-arrow-right-line text-xs" />
            </Link>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="bg-[#EAF3E7] rounded-xl border border-[#C8DFC2] p-7 text-center">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white mx-auto mb-3">
            <i className="ri-mail-line text-[#8FA882]" />
          </div>
          <p className="text-sm font-bold text-[#2C2C2C] mb-1.5">お問い合わせ・ご意見</p>
          <p className="text-xs text-[#6B6B6B] leading-relaxed mb-4">
            記事の内容に関するご質問や、サイトへのご意見・ご感想はお気軽にどうぞ。
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 text-sm font-semibold px-6 py-2.5 rounded-full bg-[#8FA882] text-white hover:bg-[#7A9570] transition-colors cursor-pointer whitespace-nowrap"
          >
            お問い合わせはこちら
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        </div>

        {/* Back link */}
        <div className="mt-8 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#8FA882] hover:text-[#7A9570] transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            トップページへ戻る
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}
